import { Directive, Renderer2, ElementRef, HostListener, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
    selector: '[forceInteger]',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ForceIntegerDirective),
        multi: true
    }]
})
export class ForceIntegerDirective implements ControlValueAccessor {
    onChange: any = () => {};
    onTouch: any = () => {};

    constructor(private renderer: Renderer2,
        private element: ElementRef) {
    }
    @HostListener('input', ['$event.target.value'])
    input(value: string | null) {
        this.onChange(parseInt(value || '0', 10));
    }
    writeValue(value: string): void {
        const element = this.element.nativeElement;
        this.renderer.setProperty(element, 'value', value);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

}
